export default "__VITE_ASSET__D1V_LuTU__"